import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import { useRecoilState, } from 'recoil';
import { popupCustomerFlowAtom, popupTransactionHistoryAtom } from '../../state';
import banks from '../../utils/banks';
import { CURRENCY_CODE, CURRENCY_CODE_NAME } from "../../utils/Utils";

const BANK_OPTIONS = banks.map((c) => ({
  label: c.shortName,
  value: c.code,
  data: c,
}));

const CURRENCY_CODE_OPTIONS = Object.values(CURRENCY_CODE).map((c) => ({
  label: CURRENCY_CODE_NAME[c],
  value: c,
}));



const BankAccountManager = ({
  routePath = '/bank-account',
}) => {
  const clearPagi = useRef();
  const [data, setData] = useState([]);
  const [view, setView] = useState({
    edit: false,
    add: false,
    isDelete: false,
    isExchangeMoney: false,
  });

  const DEFAULT_BANK_ACCOUNT = {
    id: null,
    name: "",
    bankCode: null,
    bankNumber: null,
    currencyCode: CURRENCY_CODE.VND,
  };


  const [popupTransactionHistory] = useRecoilState(popupTransactionHistoryAtom);
  const [popupCustomerFlow] = useRecoilState(popupCustomerFlowAtom);


  const { errors, register, handleSubmit, reset, getValues, control } = useForm(
    {
      defaultValues: {
        ...DEFAULT_BANK_ACCOUNT
      },
    }
  );

  const [loading, setLoading] = useState(false);
  const [onSearchText, setSearchText] = useState("");
  const [editId, setEditedId] = useState();
  const [deleteId, setDeleteId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);


  const colTable = [
    {
      Header: "Mã",
      accessor: "id",
    },
    {
      Header: "Tên quỹ",
      accessor: "name",
    },
    {
      Header: "NH",
      accessor: (item) => BANK_OPTIONS.find(bankOption => bankOption.value === item.bankCode)?.data?.shortName,
    },
    {
      Header: "STK",
      accessor: (item) => item.bankNumber,
    },
    {
      Header: "Tiền tệ",
      accessor: (item) => CURRENCY_CODE_NAME[item.currencyCode],
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onEditClick(item.id);
                        toggle("edit");
                      }}
                    >
                      <Icon name="edit"></Icon>
                      <span>Cập nhật</span>
                    </DropdownItem>
                  </li>

                  {/* <li>
                    <DropdownItem
                      tag="a"
                      href="#money"
                      onClick={(ev) => {
                        ev.preventDefault();
                        history.push(`/bank-account/money/${item.id}`);
                      }}
                    >
                      <Icon name="money"></Icon>
                      <span>Dòng tiền</span>
                    </DropdownItem>
                  </li> */}

                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  // Changing state value when searching name
  useEffect(() => {
    setLoading(true);
    setData([]);
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {
      let params = {
      };

      if (onSearchText) {
        params.search = onSearchText;
      }

      GET(`${routePath}`, params, true)
        .then(({ data }) => {
          setData([...data]);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 400);
  }, [onSearchText, timeNow, routePath, popupTransactionHistory.updatedAt, popupCustomerFlow.updatedAt]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
    setSearchText("");

    setTimeNow(moment().valueOf());
  };

  // Submits form data
  const onHandleSubmit = () => {
    setLoading(true);
    const { name, bankCode, bankNumber, currencyCode } = getValues();

    const formData = {
      name,
      bankCode,
      bankNumber,
      currencyCode,
    };

    const request = editId
      ? PUT(`${routePath}/${editId}`, formData, {}, true)
      : POST(`${routePath}`, formData, {}, true);

    request
      .then((res) => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false, isExchangeMoney: false });
    reset({
      ...DEFAULT_BANK_ACCOUNT
    });
  };

  // function that loads the want to editted data
  const onEditClick = (id) => {
    setLoading(true);
    setEditedId(id);

    GET(`${routePath}/${id}`, {}, true)
      .then(({ data }) => {
        reset({
          ...data,
        });
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onFormCancel();

      })
      .finally(() => {
        setLoading(false);
      });
  };

  const deleteOrder = (id) => {
    if (!id) {
      return;
    }
    DELETE(`${routePath}/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa quỹ tài khoản thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };
  return (
    <React.Fragment>
      <Head title="Quản lý quỹ tài khoản"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Quỹ tài khoản</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap mw-150px">
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          placeholder="Tìm kiếm quỹ tài khoản"
                          className="form-control  border-primary"
                          value={onSearchText}
                          onChange={(e) => onFilterChange(e)}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="">
                        <Button
                          className=""
                          color="primary"
                          type='button'
                          onClick={(e) => {
                            e.preventDefault();
                            onFormCancel();
                            toggle("add");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm quỹ tài khoản</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal
          isOpen={view.add || view.edit}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Thêm quỹ tài khoản</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onHandleSubmit)}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Tên quỹ tài khoản{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            placeholder="Vui lòng nhập tên quỹ tài khoản"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="name"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Ngân hàng
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="bankCode"
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={BANK_OPTIONS}
                                value={BANK_OPTIONS.find(
                                  (c) => c.value === value
                                )}
                                onChange={(val) => onChange(val.value)}
                              />
                            )}
                          />

                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Số tài khoản
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="bankNumber"
                            render={({ onChange, value, name, ref }) => (
                              <Input
                                inputRef={ref}
                                name={name}
                                onChange={(e) => onChange(e.target.value)}
                                value={value}
                              />
                            )}
                          />

                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Tiền tệ
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="currencyCode"
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={CURRENCY_CODE_OPTIONS}
                                value={CURRENCY_CODE_OPTIONS.find(
                                  (c) => c.value === value
                                )}
                                onChange={(val) => onChange(val?.value)}
                              />
                            )}
                          />

                        </div>
                      </div>
                    </Col>
                    <Col size="12">
                      <Button color="primary" type="submit">
                        <Icon className="plus"></Icon>
                        <span>Lưu</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá quỹ tài khoản này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteOrder(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default BankAccountManager;
